import { CustomUseInfiniteQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { ApiInstance, HoldingPositionsMarket, HoldingPositionsMarketParams, RequireOnly } from '@/libs/sdk/api';
import { keepPreviousData } from '@tanstack/react-query';
import { useSSEInfiniteQuery } from '../hooks/use-sse-query';

/** Query type of the holdings overview; refetchQuery() matches it at key[1]. */
export const USER_HOLDING_POSITIONS_QUERY = 'UserHoldingPositions';

export const useUserHoldingPositions = (
  api: ApiInstance,
  searchParams: RequireOnly<HoldingPositionsMarketParams, 'uid'>,
  options?: CustomUseInfiniteQueryOptions<HoldingPositionsMarket>
) => {
  const { page = 1, pageSize = 10 } = searchParams || {};
  const { queryKey, enabled = true, ...rest } = options || {};

  return useSSEInfiniteQuery(
    api.sse,
    {
      ...rest,
      enabled: enabled && hasNonEmptyProp(searchParams, ['uid']),
      queryKey: [queryKey, USER_HOLDING_POSITIONS_QUERY, searchParams],
      initialPageParam: { page, pageSize },
      queryFn: async ({ signal, pageParam }) => {
        const { data } = await api.market.getHoldingPositionsMarket({ ...searchParams!, ...pageParam! }, { signal });
        return { ...data, ...pageParam };
      },
      placeholderData: keepPreviousData,
    },
    [{ event: 'user:position_changed' }]
  );
};
